'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  letter-spacing: 1px;\n  color: ', ';\n  text-decoration: none;\n  padding: 3px;\n  padding-left: 5px;\n  padding-right: 5px;\n  margin-left: 2px;\n  margin-right: 2px;\n  background-image: linear-gradient(\n    to bottom,\n    ', ' 50%,\n    ', ' 50%\n  );\n  background-size: 100% 200%;\n  background-position: 0 -95%;\n  transition: color 0.5s, background-position 0.5s;\n\n  &:hover {\n    color: white;\n    text-decoration: none;\n    background-position: 0 0;\n  }\n'], ['\n  letter-spacing: 1px;\n  color: ', ';\n  text-decoration: none;\n  padding: 3px;\n  padding-left: 5px;\n  padding-right: 5px;\n  margin-left: 2px;\n  margin-right: 2px;\n  background-image: linear-gradient(\n    to bottom,\n    ', ' 50%,\n    ', ' 50%\n  );\n  background-size: 100% 200%;\n  background-position: 0 -95%;\n  transition: color 0.5s, background-position 0.5s;\n\n  &:hover {\n    color: white;\n    text-decoration: none;\n    background-position: 0 0;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var A = _styledComponents2.default.a(_templateObject, function (props) {
  return props.color || 'black';
}, function (props) {
  return props.color || 'black';
}, function (props) {
  return props.bgColor || 'white';
});

var TextLink = function TextLink(props) {
  return _react2.default.createElement(A, {
    href: props.href,
    color: props.color,
    bgColor: props.bgColor
  }, props.children);
};

exports.default = TextLink;